export default "__VITE_ASSET__CCoesm_o__"